import React from 'react'
import NavBar from '../NavBar/NavBar';
import { Link } from 'react-router-dom'
import firebase from 'firebase'
const Index = () => {
    return (
        <div>
            <NavBar />

            <HomePage />
        </div>
    )
}


const HomePage = () => {
  const handleGetStarted  = () => {
      const user = firebase.auth().currentUser
      window.location.hash = user ? "#/editor" : "#/login"
  }
    return(
<div className="bg-gray-100 relative font-sans">
  <header 
    id="master-header"
    className="h-screen text-white flex flex-col justify-center  relative"
    style={{backgroundImage: "linear-gradient(135deg, #231437 0%, #2c385e 50%, #336e6b 100%)", minHeight: "760px"}}
  >
    <div
      className="z-0 absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat"
      style={{backgroundImage: "url(https://wallpaperaccess.com/full/806427.jpg)"}}>
    </div>
    <div className="z-10 relative py-12 mx-auto md:w-1/2 text-center">
      <h1 className="leading-tight mb-8 text-5xl text-center font-thin">
        The online editor
      </h1>
      <p className="text-center text-xl font-light mb-8">
        Edit html/css code, with instant results  
      </p>
      <p className="text-base font-thin">
        HTML, CSS, jQuery and Javascript editor
      </p>
      <button
        type="button"
        className="mt-6 bg-gray-100 text-gray-900 shadow hover:shadow-lg uppercase py-4 px-6 font-semibold"
        onClick={handleGetStarted}
      >
        Get Started
      </button>
      <p className="mt-4 text-xs opacity-50">
        Free snippets
      </p>
    </div>
  </header>


  <div className="w-full relative">
    <div className="flex flex-wrap pt-10 px-64 pb-0">
      <div className="md:w-1/2 w-full px-2 z-10 my-auto">
        <h2 className="text-3xl leading-tight mb-8 relative">
          Do html coding anytime anywhere
        </h2>
        <div className="">
          <button
            className="uppercase bg-gray-900 text-white px-4 py-4 shadow text-sm z-30 hover:shadow-lg"
            style={{minWidth: "136px"}}
            onClick={() => window.location.hash = '#/editor'}
          >
            Start
          </button>
        </div>        
      </div>
      <div className="md:w-1/2 w-full px-2 flex justify-end z-10">
        <img
          className="h-auto"
          style={{maxHeight: "450px"}}
          alt="Watch Thousands of shows and movies anytime, anywhere"
        //   src="https://www.hulu.com/static/hitch/s3/2018-01/mobile-devices-footer%402x.png"
        src="https://pics.freeicons.io/uploads/icons/png/14760371461555931396-512.png"
        />
      </div>
    </div> 
    <div className="block absolute w-full left-0 bg-white z-0" style={{top: "25%", height: "75%"}}>
    </div>  
  </div>
  <footer
    className="py-8 mx-auto container px-8"
  >
    <div className="flex justify-between">
    <ul className="list-none m-0 p-0 flex uppercase -mx-4 text-gray-700 text-sm">
      {/* <li className="px-2 inline-block">
        <Link to="/about" className="no-underline">About</Link>
      </li> */}
      <li className="px-2 inline-block">
        <Link to="/" className="no-underline">
          Home
        </Link>
      </li>
      {/* <li className="px-2 inline-block">
        <Link to="/#" className="no-underline">
          Help 
        </Link>
      </li> */}
    </ul>
      <p className="text-gray-800 font-bold uppercase ml-3">
        &copy; 2021 BXW
      </p>
    </div>
  </footer>
</div>
    )
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Homepage/index.jsx